const KEY = 'ktp_recently_visited';
const MAX = 6;

export function recordVisit({ id_kiinteisto, kiinteistotunnus, kohteen_nimi, osoite, postinumero, toimipaikka }) {
  try {
    const existing = getRecentVisits();
    const filtered = existing.filter(v => v.id_kiinteisto !== id_kiinteisto);
    const updated = [
      { id_kiinteisto, kiinteistotunnus, kohteen_nimi, osoite, postinumero, toimipaikka, visitedAt: Date.now() },
      ...filtered,
    ].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(updated));
  } catch {}
}

export function getRecentVisits() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch {
    return [];
  }
}
